// Wrapper to collect data from stores and pass into view component TabPanel

import PropTypes from 'prop-types'
import { observer } from 'mobx-react-lite'

import useVisit from 'hooks/useVisit'
import TabPanel from './TabPanel'

const Container = ({ areAdditionalTabsVisible, toggleChat, chatDialogVisible, hideChat, modality, inProgress }) => {
  const visit = useVisit()

  if (!visit) {
    return null
  }

  return (
    <TabPanel
      visitType={visit.visitType}
      areAdditionalTabsVisible={areAdditionalTabsVisible}
      toggleChat={toggleChat}
      hideChat={hideChat}
      chatDialogVisible={chatDialogVisible}
      modality={modality}
      inProgress={inProgress}
    />
  )
}
Container.propTypes = {
  areAdditionalTabsVisible: PropTypes.bool,
  chatDialogVisible: PropTypes.bool,
  toggleChat: PropTypes.func,
  hideChat: PropTypes.func,
  modality: PropTypes.string,
  inProgress: PropTypes.bool,
}
Container.defaultProps = {
  areAdditionalTabsVisible: false,
}

export default observer(Container)
